<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
        <circle cx="2" cy="2" r="2" fill="#BEBEBE"/>
    </svg>
</template>

<script>
export default {
    name: 'DotIcon',
    props: {
        viewBox: {
            type: [String],
            default: () => `0 0 12 12`,
        },
        type: {
            type: [String],
            default: () => `down`,
        },
    },
}
</script>
